<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().is_organization_admin">
  <h2>You do not have permission to manage accounting connections.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="alert mt-3 ml-md-4 mb-0" role="alert"
     [class.alert-success]="history.state.feedback.status == 'success'"
     [class.alert-info]="history.state.feedback.status == 'info'"
     *ngIf="history && history.state && history.state.feedback">
  {{ history.state.feedback.text }}
</div>

<div class="pt-3 pl-md-4"
     *ngIf="accountService.getMyAccount().is_organization_admin && serverError === null">

  <h2>Accounting Connections <span *ngIf="loadingConns" class="text-secondary">- Loading...</span></h2>

  <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="alert" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Name</th>
        <th scope="col">Locations</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let conn of conns.results">
        <td>{{ getAccountingSoftwareDisplay(conn.accounting_software) }}</td>
        <td>{{ conn.name }}</td>
        <td>
          <ng-container *ngIf="conn.location_names.length > 0">
            <span *ngFor="let location_name of conn.location_names" class="d-block">{{ location_name }}</span>
          </ng-container>
          <span class="text-muted" *ngIf="conn.location_names.length === 0">
            None assigned
          </span>
        </td>
        <td class="table-button-cell">
          <div class="float-right">
            <a routerLink="/accounting-connections/configure/{{ conn.id }}"
               class="btn btn-outline-success btn-sm mr-2">
              Configure
            </a>
            <button type="button" class="btn btn-outline-success btn-sm mr-2"
                    (click)="handleAssignConn(conn)">
              Assign
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm mr-2"
                    (click)="handleDuplicateConn(conn)">
              Duplicate
            </button>
            <button type="button" class="btn btn-outline-danger btn-sm mr-2"
                    (click)="handleRemoveConn(conn)">
              Remove
            </button>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingConns ? 'Loading...' : 'No connections' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <p>
    Your organization can have multiple accounting connections. This allows you to report financials to separate accounting software for individual or subsets of locations.
  </p>

  <div class="alert alert-info">
    When Capitan syncs revenue data to an accounting connection, only sales facilitated by the Capitan Climber App and Staff Site are included. Sales which originated in integrated point-of-sale software (Lightspeed, Square) will <b>not</b> be included, in order to avoid double counting. If using a POS integration, ensure that your integrated POS software is configured to report accounting data.
  </div>

  <a [href]="getXeroOAuthInitURL()"
     class="btn btn-primary mb-2">
    Connect with Xero
  </a>
  <br>
  <a [href]="getQuickbooksOAuthInitURL()"
     class="btn btn-primary mb-2">
    Connect with Quickbooks Online
  </a>
  <br>
  <button class="btn btn-primary mb-2"
          (click)="handleAddNewManualConnection()">
    Add New Manual Connection
  </button>

</div>
